import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  isActive: boolean;
  action: string;
  classNameAction?: string;
  label?: string;
  color?: string;
  onClick?: () => void;
  onHover?: () => void;
};

export default function ActionButton({
  isActive,
  label,
  action,
  color = "accent",
  className,
  classNameAction,
  onClick,
  onHover,
}: Props) {
  return (
    <button
      type="button"
      className={cn(
        "group",
        "h-[2.5rem] rounded-[0.5rem] pl-[0.4rem] pr-[0.6rem] flex items-center gap-2.5 bg-dark-900/90",
        "transition-all duration-300",
        "hover:-translate-y-[5%]",
        "active:-translate-y-[2%]",
        className,
      )}
      onClick={onClick}
      onMouseEnter={onHover}
      data-mz-accent={color}
    >
      <div
        className={cn(
          "flex items-center justify-center h-[1.75rem] min-w-[1.75rem] px-2 shrink-0 rounded-[0.4rem] ",
          "text-14 font-bold",
          isActive ? "text-white bg-gradient-accent" : "text-[#0F0F0F] bg-white",
          "group-active:text-white",
          "group-active:bg-gradient-accent group-hover:text-white group-hover:bg-gradient-accent",
          classNameAction,
        )}
      >
        {action}
      </div>
      {label && (
        <div className="whitespace-nowrap text-white text-12 font-bold uppercase">{label}</div>
      )}
    </button>
  );
}
